import assertString from './util/assertString.js';

function rtrim(str,chars){assertString(str);var strIndex=str.length-1;while(/\s/.test(str.charAt(strIndex))){strIndex-=1;}return str.slice(0,strIndex+1)}

export { rtrim as default };
//# sourceMappingURL=rtrim.js.map
